import React, { useEffect, useState } from "react";
// import Text from '../components/elements/Text';
import { NavLink, useNavigate } from "react-router-dom";
import { createUserWithEmailAndPassword, updateProfile } from "firebase/auth";
import { auth, db } from "api/firebase/firebaseConfig";
import { Formik, Field, Form } from "formik";
import { doc, setDoc } from "firebase/firestore"; // Import doc and setDoc from Firestore
import {
  Flex,
  Box,
  Card,
  CardBody,
  FormControl,
  FormErrorMessage,
  Button,
  FormLabel,
  Input,
  Heading,
  Text,
  Image,
  InputGroup,
  InputRightElement,
  Select,
} from "@chakra-ui/react";
import Logo from "assets/img/logo-papeda.png";
import ImageLogin from "assets/img/just-login-img.png";
import { useColorMode } from "@chakra-ui/react";

const Signup = () => {
  const navigate = useNavigate();
  const { colorMode } = useColorMode();
  const [errors, setErrors] = useState("");
  const [loading, setLoading] = useState(false);
  const [show, setShow] = useState(false);
  const [showConfirm, setShowConfirm] = useState(false);

  const handleClick = () => setShow(!show);
  const handleClickConfirm = () => setShowConfirm(!showConfirm);

  const initialValues = {
    nik: "",
    name: "",
    email: "",
    province: "",
    password: "",
    confirmPassword: "",
  };

  const validateForm = (values) => {
    const errors = {};

    if (!values.nik) {
      errors.nik = "NIK is required";
    } else if (values.nik.length !== 16) {
      errors.nik = "NIK must be exactly 16 characters";
    }

    if (!values.name) {
      errors.name = "Nama is required";
    } else if (values.name.length <= 3) {
      errors.name = "Must be 3 characters or more";
    }
    if (!values.province) {
      errors.province = "Province is required";
    } else if (values.province.length <= 3) {
      errors.province = "Must be 3 characters or more";
    }

    if (!values.email) {
      errors.email = "Email is required";
    } else if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(values.email)) {
      errors.email = "Invalid email address";
    }

    if (!values.password) {
      errors.password = "Password is required";
    } else if (values.password.length < 8) {
      errors.password = "Password length must be at least 8 characters";
    }

    if (values.password !== values.confirmPassword) {
      errors.confirmPassword = "Passwords do not match!";
    }

    return errors;
  };

  const onSubmitSignupForm = async (values) => {
    console.log("try submit");
    setLoading(true);
    try {
      const userCredential = await createUserWithEmailAndPassword(
        auth,
        values.email,
        values.password
      );
      const user = userCredential.user;

      // Add user data to Firestore
      const userRef = doc(db, "users", user.email);
      await setDoc(userRef, {
        id: user.uid,
        nik: values.nik, // Add the nik field
        name: values.name, // Add the name field
        province: values.province,
        email: values.email, // Add the email field
        level: "unauthorized",
        // Add other user data fields as needed
      });

      setLoading(false);
      console.log(user);

      navigate("/");
    } catch (error) {
      const errorCode = error.code;
      const errorMessage = error.message;
      setErrors(errorMessage);
      setLoading(false);
      console.log(errorCode, errorMessage);
    }

    // ...
  };
  return (
    <Flex
      justifyContent="center"
      alignItems="center"
      w="100vw"
      h="100vh"
      direction="column"
    >
      <Card
        w={"1000px"}
        h={"auto"}
        mt={"-20px"}
        color={"gray.800"}
        borderRadius={"20px"}
      >
        <CardBody>
          <Formik
            initialValues={initialValues}
            validate={validateForm}
            onSubmit={(values) => onSubmitSignupForm(values)}
          >
            {({
              values,
              errors,
              touched,
              handleChange,
              handleBlur,
              handleSubmit,
              isSubmitting,
            }) => (
              <Form>
                <Flex
                  direction="row"
                  alignItems="start"
                  gap={10}
                  height={"100%"}
                >
                  <Flex
                    justifyContent={"center"}
                    alignItems={"center"}
                    mr={"-20px"}
                    mt={"12px"}
                    w="18%"
                    direction={"column"}
                    gap={"12px"}
                  >
                    <Image src={Logo} w={"auto"} h={"90px"} alt="logo-just" />
                    <Heading
                      size={"sm"}
                      color={colorMode === "dark" ? "gray.100" : "gray.800"}
                      textAlign={"left"}
                    >
                      Dashboard Pemantauan Penyaluran Dana Papua
                    </Heading>
                  </Flex>
                  <Box
                    h={"100%"}
                    w={"5px"}
                    bg={colorMode === "dark" ? "rgb(63 68 78)" : "gray.100"}
                    // mx={'-20px'}
                    mt={"-19px"}
                  />
                  <Flex direction="column" w="300px" borderLeft={"5 px solid"}>
                    <Heading
                      size={"sm"}
                      color={colorMode === "dark" ? "gray.100" : "gray.800"}
                      textAlign={"left"}
                      mt={"12px"}
                      mb={"20px"}
                    >
                      Buat Akun Baru
                    </Heading>
                    <FormControl isInvalid={errors.nik}>
                      <FormLabel
                        color={colorMode === "dark" ? "gray.100" : "gray.800"}
                      >
                        NIK
                        <Text
                          as="span"
                          color={colorMode === "dark" ? "gray.100" : "red.800"}
                          fontSize="lg"
                          position="relative"
                          top="-0.2em"
                          ml={1}
                        >
                          *
                        </Text>
                      </FormLabel>
                      <Input
                        color={colorMode === "dark" ? "gray.100" : "gray.800"}
                        type="text"
                        id="nik"
                        name="nik"
                        value={values.nik}
                        onChange={(e) => {
                          handleChange(e);
                          setErrors(null);
                        }}
                      />
                      {errors.nik && touched.nik && (
                        <FormErrorMessage>
                          Tolong Masukkan NIK Anda
                        </FormErrorMessage>
                      )}
                    </FormControl>

                    <FormControl isInvalid={errors.email} mt="20px">
                      <FormLabel
                        color={colorMode === "dark" ? "gray.100" : "gray.800"}
                      >
                        Alamat Email
                        <Text
                          as="span"
                          color={colorMode === "dark" ? "gray.100" : "red.800"}
                          fontSize="lg"
                          position="relative"
                          top="-0.2em"
                          ml={1}
                        >
                          *
                        </Text>
                      </FormLabel>
                      <Input
                        color={colorMode === "dark" ? "gray.100" : "gray.800"}
                        type="email"
                        id="email"
                        name="email"
                        value={values.email}
                        onChange={(e) => {
                          handleChange(e);
                          setErrors(null);
                        }}
                      />
                      {errors.email && touched.email && (
                        <FormErrorMessage>
                          Tolong Masukkan email Anda
                        </FormErrorMessage>
                      )}
                    </FormControl>
                    <FormControl isInvalid={errors.password} mt="60px">
                      <FormLabel
                        color={colorMode === "dark" ? "gray.100" : "gray.800"}
                      >
                        Password
                        <Text
                          as="span"
                          color={colorMode === "dark" ? "gray.100" : "red.800"}
                          fontSize="lg"
                          position="relative"
                          top="-0.2em"
                          ml={1}
                        >
                          *
                        </Text>
                      </FormLabel>
                      <InputGroup>
                        <Input
                          type={show ? "text" : "password"}
                          value={values.password}
                          onChange={(e) => {
                            handleChange(e);
                            setErrors(null);
                          }}
                          name="password"
                          id="password"
                        />
                        <InputRightElement width="4.5rem">
                          <Button h="1.75rem" size="sm" onClick={handleClick}>
                            {show ? "Hide" : "Show"}
                          </Button>
                        </InputRightElement>
                      </InputGroup>
                      {errors.password && (
                        <FormErrorMessage>{errors.password}</FormErrorMessage>
                      )}
                    </FormControl>

                    <Flex
                      justifyContent={"start"}
                      alignItems={"center"}
                      gap={1}
                      mt={"50px"}
                    >
                      <Text
                        fontSize="12px"
                        color={colorMode === "dark" ? "gray.100" : "gray.800"}
                      >
                        Sudah punya akun?{" "}
                      </Text>
                      <NavLink to="/signin" className="underline text-tertiary">
                        <Text
                          color={colorMode === "dark" ? "gray.100" : "gray.800"}
                          fontSize="12px"
                        >
                          <u>Masuk</u>
                        </Text>
                      </NavLink>
                    </Flex>
                  </Flex>
                  <Flex
                    direction="column"
                    justifyContent="start"
                    w="300px"
                    mt="49px"
                  >
                    <FormControl isInvalid={errors.name}>
                      <FormLabel
                        color={colorMode === "dark" ? "gray.100" : "gray.800"}
                      >
                        Nama Lengkap (Tanpa Gelar)
                        <Text
                          as="span"
                          color={colorMode === "dark" ? "gray.100" : "red.800"}
                          fontSize="lg"
                          position="relative"
                          top="-0.2em"
                          ml={1}
                        >
                          *
                        </Text>
                      </FormLabel>
                      <Input
                        color={colorMode === "dark" ? "gray.100" : "gray.800"}
                        type="text"
                        id="name"
                        name="name"
                        value={values.name || ""}
                        onChange={(e) => {
                          const uppercasedValue = e.target.value.toUpperCase();
                          e.target.value = uppercasedValue;
                          handleChange(e);
                          setErrors(null);
                        }}
                      />
                      {errors.name && touched.name && (
                        <FormErrorMessage>
                          Tolong Masukkan Nama Anda
                        </FormErrorMessage>
                      )}
                    </FormControl>
                    <FormControl isInvalid={errors.province} mt="20px">
                      <FormLabel
                        color={colorMode === "dark" ? "gray.100" : "gray.800"}
                      >
                        Provinsi
                        <Text
                          as="span"
                          color={colorMode === "dark" ? "gray.100" : "red.800"}
                          fontSize="lg"
                          position="relative"
                          top="-0.2em"
                          ml={1}
                        >
                          *
                        </Text>
                      </FormLabel>
                      <Select
                        color={colorMode === "dark" ? "gray.100" : "gray.800"}
                        id="province"
                        name="province"
                        value={values.province}
                        onChange={(e) => {
                          handleChange(e);
                          setErrors(null);
                        }}
                      >
                        <option value="">Pilih Provinsi Anda</option>
                        <option value="papua">Papua</option>
                        <option value="papua-barat">Papua Barat</option>
                        <option value="papua-barat-daya">
                          Papua Barat Daya
                        </option>
                        <option value="papua-tengah">Papua Tengah</option>
                        <option value="papua-selatan">Papua Selatan</option>
                        <option value="papua-pegunungan">
                          Papua Pegunungan
                        </option>
                        <option value="semua-provinsi">Semua Provinsi</option>
                      </Select>
                      {errors.province && touched.province && (
                        <FormErrorMessage>
                          Tolong Pilih Provinsi Anda
                        </FormErrorMessage>
                      )}
                    </FormControl>

                    <FormControl isInvalid={errors.confirmPassword} mt="60px">
                      <FormLabel
                        color={colorMode === "dark" ? "gray.100" : "gray.800"}
                      >
                        Konfirmasi Password
                        <Text
                          as="span"
                          color={colorMode === "dark" ? "gray.100" : "red.800"}
                          fontSize="lg"
                          position="relative"
                          top="-0.2em"
                          ml={1}
                        >
                          *
                        </Text>
                      </FormLabel>
                      <InputGroup>
                        <Input
                          color={colorMode === "dark" ? "gray.100" : "gray.800"}
                          type={showConfirm ? "text" : "password"}
                          id="confirmPassword"
                          name="confirmPassword"
                          value={values.confirmPassword}
                          onChange={(e) => {
                            handleChange(e);
                            setErrors(null);
                          }}
                        />
                        <InputRightElement width="4.5rem">
                          <Button
                            h="1.75rem"
                            size="sm"
                            onClick={handleClickConfirm}
                          >
                            {showConfirm ? "Hide" : "Show"}
                          </Button>
                        </InputRightElement>
                      </InputGroup>
                      {errors.confirmPassword && (
                        <FormErrorMessage>
                          {errors.confirmPassword}
                        </FormErrorMessage>
                      )}
                    </FormControl>

                    <Flex
                      justifyContent={"end"}
                      alignItems={"center"}
                      mt={"50px"}
                    >
                      <Button type="submit" colorScheme={"blue"} w={"100px"}>
                        <span>{loading ? "Memuat..." : " Daftar "}</span>
                      </Button>
                    </Flex>
                  </Flex>
                </Flex>
              </Form>
            )}
          </Formik>
        </CardBody>
      </Card>
      <Text color="red" my="12px" textAlign="right" float="right">
        {errors && errors}
      </Text>
    </Flex>
  );
};

export default Signup;
